import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal, IconButton, Button } from '@mui/material';
import React from 'react';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%', // ✅ Responsive width
  maxWidth: 550, // ✅ Limit max width for desktop
  maxHeight: '90vh', // ✅ Prevent overflow on small screens
  overflowY: 'auto', // ✅ Make content scrollable if long
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: 24,
  p: { xs: 2.5, sm: 4 }, // ✅ Adjust padding for mobile
};

type UniversalPopupProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const GenericPopup: React.FC<UniversalPopupProps> = ({ isOpen, onClose, children }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="universal-modal-title"
      aria-describedby="universal-modal-description"
    >
      <Box className="cstm-popup" sx={style}>
        {/* ✅ Top-right Close Button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 10,
            bgcolor: 'white',
            boxShadow: 1,
            '&:hover': { bgcolor: '#f3f4f6' },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* ✅ Dynamic Content */}
        <Box sx={{ pb: 3 }}>{children}</Box>

        {/* ✅ Bottom Center Close Button */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            position: 'sticky',
            bottom: 0,
            bgcolor: 'transparent',
            py: 2,
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            sx={{
              borderRadius: '50px',
              px: 4,
              textTransform: 'none',
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
